import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { LoginResponse } from "./Login/LoginResponse";

const ENDPOINT = "/Auth/ChangePassword";

export class ChangePasswordCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    newPassword: ChangePasswordRequest;

    constructor(newPassword: string) {
        super();
        this.newPassword = new ChangePasswordRequest(newPassword);
    }

    public async execute(): Promise<LoginResponse> {
        var res = await this.executeCommand(this.newPassword);
        return new LoginResponse(res);
    }
}

class ChangePasswordRequest {
    newPassword: string;

    constructor(newPassword: string) {
        this.newPassword = newPassword;
    }
}
